<template>
  <div class="banner" ref="banner" :style="genBgStyle()" v-loading="bannerVisibility" v-on="$listeners">
    <template v-if="logoConfig.isLogo">
      <img
        v-if="logoImg"
        class="logo-img"
        :src="logoImg.filePath"
        :style="{
          height: logoConfig.height + 'px',
        }"
      />
      <span
        v-else-if="logoContent"
        class="logo-content"
        :style="{
          fontSize: logoConfig.fontSize + 'px',
          height: logoConfig.height + 'px',
          lineHeight: logoConfig.height + 'px',
          left: logoConfig.positionX + 'px',
          top: logoConfig.positionY + 'px',
        }"
        >{{ logoContent }}</span
      >
    </template>

    <div
      class="left_element"
      :style="genElementStyle('Left')"
      v-show="elConfig.remainPart === 1 || elConfig.remainPart === 0"
    >
      <img
        :src="materialUrl(elementImg)"
        :style="{ width: `${elConfig.elementWidth * 2}px` }"
        alt="banner左侧元素"
      />
    </div>
    <div
      class="right_element"
      :style="genElementStyle('Right')"
      v-show="elConfig.remainPart === 2 || elConfig.remainPart === 0"
    >
      <img
        ref="RImg"
        :src="materialUrl(elementImg)"
        :style="{ width: `${elConfig.elementWidth * 2}px` }"
        alt="banner右侧元素"
      />
    </div>
    <div class="text_box" v-if="textStyle.length" :style="genTextBoxStyle()">
      <div class="banner__text" v-for="(textItem, index) in textStyle" :key="index" :style="genTextStyle(textItem)">
        {{ bannerTextValue[index] || "请输入文字" }}
      </div>
    </div>
  </div>
</template>

<script>
import { hexToRGB } from "@/assets/scripts/utils";
import { getLabelStyleMenu, materialUrl } from "@/assets/scripts/common.js";
import { mapState } from "vuex";
export default {
  name: "AiBannerBannergenerator",
  props: {
    bannerName: {
      required: false,
      type: String,
    },
    size: {
      required: false,
      type: Object,
      default: () => ({
        width: 960,
        height: 240,
      }),
    },
    bannerTextValue: {
      required: false,
      type: Array,
    },
    bgConfig: {
      required: true,
      type: Object,
    },
    elementImg: {
      required: true,
      type: String,
    },
    textInfo: {
      required: true,
      type: Object,
    },
    textStyle: {
      default: () => [],
      type: Array,
    },
    elConfig: {
      required: false,
      type: Object,
      default: () => ({
        elementWidth: 480,
        elementHeight: 240,
        offsetX: 0,
        remainPart: 0,
      }),
    },
    logoContent: {
      required: false,
      type: [String, Number],
    },
    logoConfig: {
      required: false,
      type: Object,
      default: () => ({
        fontSize: 14,
        height: 34,
        positionX: 0,
        positionY: 0,
        isLogo: 1,
      }),
    },
  },
  data() {
    return {
      bannerVisibility: false,
    };
  },
  computed: {
    ...mapState("banner", ["logoOptions"]),
    bannerImg() {
      return {
        bgConfig: this.bgConfig,
        elementImg: this.elementImg,
      };
    },
    textAlignType() {
      return this.textInfo.textAlignType;
    },
    textPositionX() {
      return this.textInfo.textPositionX;
    },
    textPositionY() {
      return this.textInfo.textPositionY;
    },
    // 如果是logo图，则返回图片地址，否则返回空
    logoImg() {
      if (!this.logoContent) return null;
      return this.logoOptions.find(item => item.id.toString() === this.logoContent.toString());
    },
  },
  watch: {
    bannerImg: {
      handler(newImg) {
        this.bannerVisibility = true;
        this.imgLoading(newImg);
      },
    },
  },
  methods: {
    materialUrl,
    imgLoading(newImg) {
      Promise.all([this.getImg(newImg.bgConfig && newImg.bgConfig.src), this.getImg(newImg.elementImg)]).then(() => {
        this.bannerVisibility = false;
        this.$emit("loaded");
      });
    },
    getImg(imgUrl) {
      return new Promise(resolve => {
        if (!imgUrl) {
          resolve(true);
          return;
        }
        const img = new Image();
        img.onload = () => resolve(true);
        img.onerror = () => resolve(false);
        img.src = materialUrl(imgUrl);
      });
    },
    genBgStyle() {
      return {
        width: `${this.size.width}px`,
        height: `${this.size.height}px`,
        backgroundImage: `url('${materialUrl(this.bgConfig.src)}')`,
      };
    },
    genElementStyle(type) {
      let styleObj = {
        width: `${this.elConfig.elementWidth}px`,
        height: `${this.elConfig.elementWidth / 2}px`,
      };
      styleObj[`margin${type}`] = `${-this.elConfig.offsetX}px`;
      styleObj.marginBottom = `${-this.elConfig.offsetY}px`;
      return styleObj;
    },
    genTextBoxStyle() {
      return {
        top: this.textPositionY + "px",
        left: this.textPositionX + "" === "-1" ? "50%" : this.textPositionX + "px",
        transform: this.textPositionX + "" === "-1" ? "translateX(-50%)" : "",
        textAlign: this.textAlignType + "" === "0" ? "center" : "left",
        textShadow: `rgba(${hexToRGB(this.bgConfig.textShadowColor)},.6) 0px 2px 4px`,
      };
    },
    genTextStyle(textItem) {
      let styleObj = {
        color: textItem.fontColor,
        marginTop: textItem.marginTop + "px",
        fontSize: textItem.fontSize + "px",
        fontFamily: textItem.fontFamily,
      };
      const { tagBgColor } = this.bgConfig;
      const labelStyleMap = getLabelStyleMenu(tagBgColor || "");
      const labelMap = labelStyleMap[textItem.labelStyle.substr(-1)];
      const labelStyle = (labelMap && labelMap.style) || {};
      if (textItem.showLabelStyle && textItem.labelStyle.length > 0) {
        Object.assign(styleObj, {
          display: "inline-block",
          lineHeight: "1.3em",
          padding: "0 0.5em .1em",
          textShadow: "none",
          ...labelStyle,
        });
      }
      return styleObj;
    },
  },
};
</script>

<style lang="scss" scoped>
.banner {
  position: relative;
  background: no-repeat center center;
  background-size: cover;
  height: 100%;
  z-index: 10;
  overflow: hidden;

  .banner__element {
    position: absolute;
    top: 0;
    width: 100%;
    z-index: 1;
  }

  .left_element,
  .right_element {
    position: absolute;
    height: 100%;
    overflow: hidden;
    z-index: 10;

    img {
      position: absolute;
      height: auto;
      bottom: 0;
    }
  }

  .left_element {
    img {
      left: 0;
    }
  }

  .right_element {
    img {
      right: 0;
    }
  }

  .logo-content {
    position: absolute;
    padding: 0 12px;
    z-index: 12;
    border-radius: 0px 0px 10px 0px;
    border-right: 1px solid #fff;
    border-bottom: 1px solid #fff;
    background: linear-gradient(90deg, #e1c568 1.79%, #dda930 99.01%);
    color: #fff;
    font-weight: 600;
  }

  .logo-img {
    z-index: 12;
    position: absolute;
  }

  .text_box {
    position: absolute;
    // white-space: nowrap;
    text-align: center;
    z-index: 999;
    line-height: 1;
    color: #fff;
    .banner__text {
      white-space: nowrap;
    }
  }

  .left_element {
    bottom: 0;
    left: 0;
  }

  .right_element {
    bottom: 0;
    right: 0;
  }
}
</style>
